module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGURES")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 1")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An “elephant tree” (marula tree, "), _c('em', [_vm._v("Sclerocarya birrea")]), _vm._v(") in the shape of the actual animal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 2")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claudius defeating Britannia, in a relief from the Sebasteion in Aphrodisias")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 3")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Latin inscription including the words SACERDOTI VICTORIAE | BRITANN")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 4")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The "), _c('em', [_vm._v("Laus Caesaris")]), _vm._v(", a song praising Claudius after his return from Britannia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 5")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inscription from the Arch of Claudius, Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 6")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drawing of the Arch of Claudius, Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 7")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cameo showing Augustus as Alexander-Zeus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 8")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great/Hague Cameo, showing an emperor with his family on the triumphal chariot")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 9")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Roman "), _c('em', [_vm._v("aureus")]), _vm._v("; the reverse depicts Vespasian on the triumphal chariot and a captive being led by a soldier before him")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 10")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Claudian table, which preserves a speech of Claudius before the Roman senate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 11")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claudius with figures representing land and sea, in a relief from the Sebasteion in Aphrodisias")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 12")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The triumph of Bacchus with echoes of the Roman ritual, on a sarcophagus at the Villa Medici")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 13")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cameo showing Augustus in a chariot drawn by Tritons")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 14")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arch of Titus, Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 15")])])])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexamenos graffito, Rome, ca. 200 CE")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df4aebe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Figures.vue
// module id = 72
// module chunks = 0